import { Box, Paper, Typography, List, ListItem, Button } from '@mui/material';
// Utils
import { colors } from '@/theme';

export const SearchError = ({ search, resetSearch }) => (
  <Paper>
    <Typography variant="h3">
      {`We were unable to find a match for `}
      <Box
        component="span"
        sx={{ color: colors.primary.main }}
        data-core-qa="searchTitleHighlightedText"
      >
        {`'${search}'`}
      </Box>
      ...
    </Typography>
    <Box sx={{ marginTop: '16px' }}>
      <Typography variant="h4" data-core-qa="searchSubText">
        Search Help:
      </Typography>
      <List>
        <ListItem dense>
          <Typography variant="body1">
            Check your search for typos and spelling errors
          </Typography>
        </ListItem>
        <ListItem dense>
          <Typography variant="body1">Use more generic search terms</Typography>
        </ListItem>
        <ListItem dense>
          <Typography variant="body1">
            {`The product you're searching for may be discontinued or not yet on our site`}
          </Typography>
        </ListItem>
      </List>
    </Box>
    <Box sx={{ marginTop: '16px' }}>
      <Button variant="outlined" color="primary" onClick={resetSearch}>
        Clear Search
      </Button>
    </Box>
  </Paper>
);
